var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute w-screen h-screen top-0 left-0 bg-black z-0",style:({ opacity: (100 - _vm.lightLevel) / 100 }),attrs:{"id":"lighting-backdrop"}})}
var staticRenderFns = []

export { render, staticRenderFns }